module.exports = __webpack_public_path__ + "static/media/gb-nir.c39480d5.svg";